import React from "react";
import DynamicSelect from "../../../shared/DynamicSelect";
import { useState } from "react";
import NumberInput from "../../../shared/NumberInput";
import { DeleteTwoTone} from "@material-ui/icons";
import { useEffect } from "react";
import DynamicSelectWithSearch from "../../../shared/DynamicSelectWithSearch";
import { formatValidInput, formatValidSelect } from "../../../../helpers/FormatHelper";
import { getBankAccountsByPerson } from "../../../../networking/NetworkingBankAccounts";

export function OutgoingRow({ rowObject, rowID, currenciesList, onDeleteRow, onUpdateFieldRow, validations,
  instruments, deliveryMethods, amountIsValid, recipientList}) {

    const [amount, setAmount] = useState(0);
    const [currencyID, setCurrencyID] = useState('');
    const [sellScale, setSellScale] = useState(2);  
    const [instrument, setInstrument] = useState('');
    const [instrumentsFilter, setInstrumentsFilter] = useState(instruments);
    const [deliveryMethod, setDeliveryMethod] = useState('');
    const [deliveryMethodsFilter, setDeliveryMethodsFilter] = useState([]);
    const [recipientType, setRecipientType] = useState('Beneficiary');
    const [recipientID, setRecipientID] = useState(-1);
    const [bankAccounts, setBankAccounts] = useState([]);


    useEffect(() => {
    if (rowObject.CurrencyID) {     
        if(recipientType !== rowObject.RecipientType)
        {     
          setRecipientType(rowObject.RecipientType);  
        }

        if(recipientID !== rowObject.RecipientID)
        {     
          const selectCcy = currenciesList.find(c=> c.value===rowObject.CurrencyID);

          loadFieldInfo({value: rowObject.RecipientID, name: rowObject.RecipientName, PersonID: rowObject.PersonID, RecipientType: rowObject.RecipientType}
            , rowObject.Amount, selectCcy, rowObject.Instrument, rowObject.DeliveryMethod)
        
        }

        
    }
  }, [rowObject, currenciesList]);

  const loadFieldInfo = async (recipient, amount, currency, instrument, deliveryMethod) => {
      setRecipientID(recipient.value);
      setRecipientType(recipient.RecipientType);
      setCurrencyID('');

        const accountsResponse = await getBankAccountsByPerson(recipient.PersonID);
        if (accountsResponse !== undefined && accountsResponse.bankAccounts !== undefined) 
        {
          const accounts = accountsResponse.bankAccounts.map(c => ({ ...c, name: `${c["Bank"]} - ${c["Account Number"]}`, value: c["Account ID"] }));
          setBankAccounts(accounts);
        }

      setCurrencyID(currency.value);
      setSellScale(currency.NumberOfDecimals);
      setAmount(amount);


      let methodsFilter = isNaN(instrument) ? deliveryMethods[instrument] : deliveryMethods['Electronic Funds Transfer'];
      if(methodsFilter === undefined || instrument === "Client's Vostro Account"){
        methodsFilter = [];
      }
      setInstrument(instrument);
      setDeliveryMethodsFilter(methodsFilter);
      setDeliveryMethod(deliveryMethod);

  }


  
  useEffect(() => {
    if(currencyID !== '')
    {
      const accounts = bankAccounts.filter(b => b.Currency === currencyID);        
    
  
      const inst = (recipientType === 'Beneficiary') ? instruments.filter(i => !i.value.includes('Hold')): instruments;


      if(accounts && accounts.length > 0){
        const newInstruments = [...new Set([...inst, ...accounts])];

          setInstrumentsFilter(newInstruments);
      }
      else{
          setInstrumentsFilter(inst);
      }
    }
      
  }, [recipientType, currencyID, bankAccounts]);


  const dropdownRecipientChangeHandler = async (item) =>{
    if (item && item.value && item.name) {
        setRecipientID(item.value);
        setRecipientType(item.RecipientType);
        setCurrencyID('');
        onUpdateFieldRow(rowID, 'RecipientID', item.value);
        onUpdateFieldRow(rowID, 'RecipientName', item.name);        
        onUpdateFieldRow(rowID, 'RecipientType', item.RecipientType);
        onUpdateFieldRow(rowID, 'PersonID', item.PersonID);
        onUpdateFieldRow(rowID, 'CurrencyID', '');
        onUpdateFieldRow(rowID, 'Instrument', -1);
        onUpdateFieldRow(rowID, 'BankAccountName', '');

        const accountsResponse = await getBankAccountsByPerson(item.PersonID);
        if (accountsResponse !== undefined && accountsResponse.bankAccounts !== undefined) 
        {
          const accounts = accountsResponse.bankAccounts.map(c => ({ ...c, name: `${c["Bank"]} - ${c["Account Number"]}`, value: c["Account ID"] }));
          setBankAccounts(accounts);
        }
    }    
  }

  const dropdownCurrenciesChangeHandler = async(item) =>
    {
       if(item.value && item.value !== '')
      { 
        if(rowObject.CurrencyID !== '' && rowObject.CurrencyID === item.value )
            {    
                setCurrencyID(rowObject.CurrencyID);
            }
            else{
                setCurrencyID(item.value);
                setAmount(0);
                setSellScale(item.NumberOfDecimals);

                onUpdateFieldRow(rowID, 'CurrencyID', item.value);
                onUpdateFieldRow(rowID, 'CurrencyName', item.name);
                onUpdateFieldRow(rowID, 'CurrencyScale', item.NumberOfDecimals);
                onUpdateFieldRow(rowID, 'Amount', 0);
            }
        }
    }

    const onBlurAmount = async() =>{      
      if(!amountIsValid(rowID,amount,currencyID))
      {
        setAmount(0);
        onUpdateFieldRow(rowID, 'Amount', 0);
      }
      else
      {
        onUpdateFieldRow(rowID, 'Amount', amount);
      }
    }
    
    const onDeleteOrderRow = () => {
      onDeleteRow(rowID);
    };
  
  const dropdownInstrumentChangeHandler = (item) =>
  {
    if(item.value && item.value !== '')
    {
      let methodsFilter = isNaN(item.value) ? deliveryMethods[item.value] : deliveryMethods['Electronic Funds Transfer'];
      if(methodsFilter === undefined || item.value === "Client's Vostro Account"){
        methodsFilter = [];
      }
      setInstrument(item.value);
      setDeliveryMethodsFilter(methodsFilter);
      onUpdateFieldRow(rowID,'Instrument',item.value);
      onUpdateFieldRow(rowID,'BankAccountName',isNaN(item.value) ?'':item.name);
    }
  }

  const dropdownDeliveryMethodChangeHandler = (item) =>
  {
       if(item.value && item.value !== '')
      {
        setDeliveryMethod(item.value);
        onUpdateFieldRow(rowID, 'DeliveryMethod', item.value);
      }
  }

  const onChangeAmount =  (event) => 
    {
      setAmount(event.target.value);
    }

    return <>
    
    <tr key={rowID}>
        <td width="25%">  
              <DynamicSelectWithSearch id={`dd-recipient-${rowID}`}
              key={`dd-recipient-${rowID}`}
              className={formatValidSelect(validations.RecipientID)}
              data={recipientList}
              placeholder={`Select a Recipient...`}
              getValue={dropdownRecipientChangeHandler}
              objValue={{ value: recipientID }}/>     
        </td>
        
        <td width="15%">
            <DynamicSelectWithSearch id={`dd-currencies-${rowID}`}
              key={`dd-currencies-${rowID}`}
              className={formatValidSelect(validations.CurrencyID)}
              data={currenciesList}
              placeholder='Select currency...'
              getValue={dropdownCurrenciesChangeHandler}
              objValue={{ value: currencyID }}/>     
        </td>
        
        <td width="15%">
            <NumberInput id={`txt-amount-${rowID}`} key={`txt-amount-${rowID}`} className={formatValidInput(validations.Amount)} value={amount} 
            onBlur={onBlurAmount} onChange ={onChangeAmount} scale={sellScale} type="Currency" />
        </td>

        <td width="25%">  
              <DynamicSelect key={`dd-instrument-${rowID}`}
                id={`dd-instrument-${rowID}`}
                className={formatValidSelect(validations.Instrument)}
                data={instrumentsFilter}
                placeholder='Select a instrument...'
                getValue={dropdownInstrumentChangeHandler}
                objValue={{value:instrument}}/> 
        </td>
        
        <td width="15%">  
              <DynamicSelect key={`dd-condition-${rowID}`}
                id={`dd-condition-${rowID}`}
                className={formatValidSelect(validations.DeliveryMethod)}
                data={deliveryMethodsFilter}
                placeholder='Select a delivery method...'
                getValue={dropdownDeliveryMethodChangeHandler}
                objValue={{value:deliveryMethod}}
                disabled={instrument && instrument.toString().includes('Hold')}
                /> 
        </td>
        <td width="5%">
              <DeleteTwoTone id={`delete-row-${rowID}`} key ={`delete-row-${rowID}`} style={{ marginRight: '10px', marginTop: '10px', cursor:'pointer'  }} onClick={onDeleteOrderRow} />

        </td>
    </tr>

  </>
}

export default OutgoingRow